import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";
import URL from "@core/scripts/helper/url";
import Logger from "@core/scripts/components/logger";

export default function addCoupon(coupon, onSuccess, onInvalid, onRequestFailure, page) {
    fetchWithCSRF(URL.toAbsolute('/buy/coupons/?page=' + page), {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json'
        }),
        body: JSON.stringify({
            coupon: coupon
        })
    })
    .then(async response => {
        if (response.redirected) {
            window.location.href = response.url;
            return null;
        }
        if (!response.ok) {
            return onRequestFailure();
        }
        const data = await response.json();
        if (data.coupon?.valid) {
            return onSuccess(data);
        }
        const messages = data.coupon?.couponMessages || [];
        return onInvalid(messages[0]?.description, data.showCouponInfoAccordion);
    })
    .catch(error => {
        Logger.error('saving coupon failed.', error);
        onRequestFailure(error);
    });
}
